import IRepo from "../../../interfaces/repo";
import Repo from "../../../state/modules/repo";
import Provider from "../../../providers/new/provider";
import DetailView from "../detailView";
import PublishedDetailView from "../publishedDetailView";
import TrackedModel from "~/models/tracked/trackedModel";
import Guid from "~/helpers/guid";

export default class RelationSectionLinkedDetailView extends TrackedModel {
  rootModel: DetailView | PublishedDetailView;
  except = ['detailView', 'createEmbeddedObject', 'organization', 'saveTimer', '_organization'];
  property_client_id: string;
  related_object_model_id: string;
  detail_view_id: string;

  static repo: IRepo<RelationSectionLinkedDetailView> = new Repo<RelationSectionLinkedDetailView>('relationSectionLinkedDetailViews', RelationSectionLinkedDetailView, {}, new Provider(RelationSectionLinkedDetailView, 'content_element', 'content_elements'));
  repo: IRepo<this, Provider<this>>;

  constructor(parent, {related_object_model_id, detail_view_id}) {
    super();
    this.parent = parent;
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('related_object_model_id', related_object_model_id)
    this.defineProperty('detail_view_id', detail_view_id)
  }

  static get rootName(): string {
    return 'relation_section_linked_detail_views';
  }

  get rootName(): string {
    return 'relation_section_linked_detail_views';
  }

  get objectModel(){
    return this.rootModel.objectModel
  }

  get publishedObjectModel() {
    return this.rootModel.published_object_model;
  }

  addToRepo(): void {
    RelationSectionLinkedDetailView.repo.add(this)
  }

}